import React, {useContext,createContext,useState,useEffect,useRef} from 'react';
import { useOktaAuth } from '@okta/okta-react';

const ViewContext = createContext();

const ContextProvider = ({children}) => {

    const [userId,setUserId]=useState("");
    const categoriesMenuRef = useRef(null);
    const [ediTypeMenuVisible,isEdiTypeMenuVisible]=useState(false);
    const [isaMenuVisible,isIsaMenuVisible]=useState(false);
    const [gsMenuVisible,isGsMenuVisible]=useState(false);
    const [noTpData,setNoTpData]=useState("Specify a criteria first");
    const [userType,setUserType]=useState("");
    const { oktaAuth } = useOktaAuth();
    const [searchValue, setSearchValue] = useState([]);
    const [errorWindowOpen, setErrorWindowOpen] = useState(false);
    const[gridTPData,setGridTPData] = useState([]);
    const [ediType,setEdiType]=useState([]);
    useEffect(() => {
        async function getUserDetails() {
            //gets user details after login
            const { userID, userType:usrType} = await oktaAuth.getUser();
            setUserId(userID);
            setUserType(usrType);
        }
        getUserDetails();
    },[]);

    const contextValues = {
        userId,
        userType,
        searchValue,
        setSearchValue,
        noTpData,
        setNoTpData,
        errorWindowOpen,
        setErrorWindowOpen,
        gridTPData,
        setGridTPData,
        ediTypeMenuVisible,
        isEdiTypeMenuVisible,
        ediType,
        setEdiType,
        isaMenuVisible,
        isIsaMenuVisible,
        gsMenuVisible,
        isGsMenuVisible,
        categoriesMenuRef
    }

    return (
        <ViewContext.Provider value ={contextValues}>
            {children}
        </ViewContext.Provider>
    );
}

const  useContextProvider = () => {
    const context = useContext(ViewContext);

    if (context === undefined) {
        throw new Error('useContextProvider must be used within ContextProvider.');
    }

    return context;

}

export {
    ContextProvider,
    useContextProvider
}